@import "../variables.scss";

.closeButton {
  display: none;
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  color: #576F94;
  cursor: pointer;

  @media (max-width: 992px) {
    display: block;
  }
}

.dropdownMenu {
  max-height: 600px;
  overflow: auto;
  position: absolute;
  top: 100%;
  right: 0;
  width: 300px;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  transition: all 0.3s ease-in-out;
  border: 1px solid #576F94;
  border-radius: 4px;

  @media (max-width: 992px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 2rem;
    overflow-y: auto;
    max-height: none;
  }

  a {
    text-decoration: none;
    color: black;
    padding: 1rem 2rem;
  }
}

.dropdownNotifications {
  max-height: 600px;
  overflow: auto;
  position: absolute;
  top: 100%;
  right: 50px;
  width: 300px;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  transition: all 0.3s ease-in-out;
  border: 1px solid #576F94;
  border-radius: 4px;

  @media (max-width: 992px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 2rem;
    overflow-y: auto;
    max-height: none;
  }

  a {
    text-decoration: none;
    color: black;
    padding: 1rem 2rem;
  }
}
